(function () {
  'use strict'

  require('./scss/cart-item.scss')

  const MODULE_NAME = 'thismoment.glow.component.cart-item'
  const templateUrl = require('./tpl/cart-item.html')

  angular
    .module(MODULE_NAME, [
      require('./service/glow-cart'),
      require('../../../analytics')
    ])
    .constant('CartStrings', {
      en: {
        'GLOW.CART.ADD': 'Add to Playlist',
        'GLOW.CART.REMOVE': 'Remove from Playlist'
      },
      es: {
        'GLOW.CART.ADD': 'Agregar contenido',
        'GLOW.CART.REMOVE': 'Eliminar contenido'
      },
      fr: {
        'GLOW.CART.ADD': 'Ajouter à la playlist',
        'GLOW.CART.REMOVE': 'Supprimer de la playlist'
      }
    })
    .component('thismomentGlowCartItem', {
      templateUrl: templateUrl,
      bindings: {
        item: '=',
        trackEvent: '&'
      },
      controller: cartItemController
    })

  cartItemController.$inject = ['$rootScope', 'CartStrings', 'Cart', 'SdkConfig']
  function cartItemController ($rootScope, CartStrings, Cart, SdkConfig) {
    const vm = this
    vm.$onInit = cartInit

    function cartInit () {
      const lang = SdkConfig.get('language')
      const contentId = parseInt(vm.item.id, 10)

      vm.cartOnClick = cartOnClick

      vm.strings = CartStrings[lang]
      vm.item.inCart = Cart.hasItem(contentId)

      if (!vm.item.title && !vm.item.description) {
        vm.styles = {}
        vm.styles.glowCartControl = {
          'border-top': 0,
          'margin-top': 0,
          'padding-top': 0
        }
      }

      $rootScope.$on('cart:add', updateCart)
      $rootScope.$on('cart:remove', updateCart)

      function updateCart (e, id) {
        if (contentId === parseInt(id, 10)) {
          vm.item.inCart = !vm.item.inCart
        }
      }

      function cartOnClick () {
        if (vm.item.inCart) {
          Cart.removeItem(contentId)
        } else {
          Cart.addItem(contentId)
        }

        vm.trackEvent({
          action: 'Content Converted',
          properties: {
            'event trigger': (vm.item.inCart) ? 'added to cart' : 'removed from cart'
          }
        })
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-cart/cart-item.js